<template>
<div class="containerWrapper">
  <Dialog header="Kommentarer" :visible.sync="displayModal" :style="{width: '50vw'}" :modal="true">
    <CommentList :objectId="modalCustomerPlaceId" />
    <template #footer>
        <Button label="Stäng" icon="pi pi-check" @click="closeModal" />
    </template>
  </Dialog>
  <Dialog header="Dokument" :visible.sync="displayModalDocs" :style="{width: '50vw'}" :modal="true">
    <ConnectedDocuments :groups="modalDocs" />
    <template #footer>
        <Button label="Stäng" icon="pi pi-check" @click="closeModalDocs" />
    </template>
  </Dialog>
  <div class="container details">
    <div class="row">
      <div class="col-md-10">
        <h1>
          Order {{currentOrder.data.SalesId}} {{ customerName }}
            <span v-if="currentOrder.data.GroupLoading" class="groupLoadingInfoWrapper">
               {{currentOrder.data.GroupLoading}}
              </span>
        </h1>
      </div>
      <div class="col-md-2 col">
        <p class="stateWrapper"><strong>Status: </strong><span :class="setState">{{ setState }}</span><span v-if="currentOrder.needsAttention" class="uppdaterad">Uppdaterad</span></p>
        <div v-if="currentOrder.version != undefined" class="versionWrapper">
          <p>
            <span v-if="currentOrder.data.truckVersion != undefined">
              <span v-if="currentOrder.version == currentOrder.data.truckVersion"><span class="inSync">I synk<i class="pi pi-check"></i> </span></span>
              <span v-else><span class="notInSync">Ej i synk<i class="pi pi-exclamation-triangle"></i></span></span>
            </span>
          </p>
        </div>
        <div v-if="currentOrder.data.accepted" class="acceptedWrapper">
          <p><strong>Accepterad av</strong></p>
          <ul>
            <li v-for="(acceptedObject, key) in currentOrder.data.accepted" :key="key">
              {{acceptedObject.driverName}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row orderDetailsWrapper" :class="showOnScroll">
      <div class="col-md-3 col" :class="schemaField.label" v-for="schemaField in currentSchema.groups[0].fields" :key="schemaField.id">
        <span>
          <label>{{ schemaField.label }}</label>
          <span class="updatedInfoWrapper" v-if="currentOrder.needsAttention && previousOrder != null && matchData(currentOrder.data[schemaField.model], previousOrder.data[schemaField.model]) != ''">
            {{orderUpdatedLabel}}: {{ matchData(currentOrder.data[schemaField.model], previousOrder.data[schemaField.model]) }}
          </span>
          <p v-if="schemaField.model === 'DeliveryPlace'"> {{ endCustomerName }} </p>
          <p v-else-if="schemaField.model === 'kund'"> Feralco Nordic AB </p>
          <p v-else-if="schemaField.model === 'Quantity'"> {{parseFloat(currentOrder.data.Quantity.replace(',','.')).toFixed(2).toLocaleString()}}  </p>
          <p v-else>{{currentOrder.data[schemaField.model]}}</p>
        </span>
      </div>
    </div>
    <TabView>
      <TabPanel header="Information">
        <div class="row orderDetailsWrapper">
              <div class="col-md-3 col" :class="schemaField.label" v-for="schemaField in currentSchema.groups[0].fields" :key="schemaField.id">
              <span>
                <label>{{ schemaField.label }}</label>
                <span class="updatedInfoWrapper" v-if="currentOrder.needsAttention && previousOrder != null && matchData(currentOrder.data[schemaField.model], previousOrder.data[schemaField.model]) != ''">
                  {{orderUpdatedLabel}}: {{ matchData(currentOrder.data[schemaField.model], previousOrder.data[schemaField.model]) }}
                </span>
                <span v-if="currentOrder.needsAttention && previousOrder != null && matchData(currentOrder.data[schemaField.model], previousOrder.data[schemaField.model]) != ''">
                  <Button icon="pi pi-check" class="p-button-success" @click="updateLiveField(schemaField.model, previousOrder.data[schemaField.model])" />
                 </span>
                <p v-if="schemaField.model === 'DeliveryPlace'"> {{ endCustomerName }} </p>
                <p v-else-if="schemaField.model === 'kund'"> Feralco Nordic AB </p>
                <p v-else-if="schemaField.model === 'Quantity'">
                  {{parseFloat(currentOrder.data.Quantity.replace(',','.')).toFixed(2).toLocaleString()}}
                </p>
                <p v-else>
                    {{currentOrder.data[schemaField.model]}}
                </p>
              </span>
            </div>
        </div>
        <div v-if="!['makulerad', 'fakturerad', 'makulerad_externt'].includes(currentOrder.state)" class="row">
          <form class="formGeneratorWithColumns feralcoOrderDetailsActiveWrapper">
            <vue-form-generator tag="div" :schema="activeSchema" :model="currentOrder.data" @model-updated="onModelUpdated" />
          </form>
        </div>
      </TabPanel>
      <TabPanel v-if="orderHistory != null" header="Historik">
        <div class="row">
          <div class="col-md-12">
            <OrderHistory :orderHistory="orderHistory" />
          </div>
        </div>
      </TabPanel>
      <TabPanel v-if="currentOrder.data.orderRows" class="reportedPanel" header="Rapporterat">
        <ActivityTable v-for="orderRow in currentOrder.data.orderRows" :activities="orderRow.actions" :orderRow="orderRow" :orderType="currentOrder.type" :key="orderRow.id" :customerPlaces="customerPlacesToReported" :isOpen="true" :showTotal="false" />
      </TabPanel>
    </TabView>
  </div>
  <div v-if="isExternalUser == false" class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <SplitButton v-if="!['makulerad', 'makulerad_externt', 'fakturerad'].includes(currentOrder.state)" label="Spara" :model="saveButtons" class="p-button-success" @click="onSave(currentOrder)" icon="pi pi-check" ></SplitButton>
        <Button v-if="!['makulerad', 'fakturerad', 'makulerad_externt'].includes(currentOrder.state)" label="Kopiera info" class="p-button-success" @click="onCopyInfo()" icon="pi pi-file" ></Button>
        <Button v-if="['aktiv', 'lastad', 'sparad'].includes(currentOrder.state)" label="Avsluta" @click="onFinished(currentOrder)"/>
        <Button v-if="currentOrder.state === 'avslutad' && currentOrder.state !='fakturaredo'" label="Klar för fakturering" @click="onReadyForInvoice(currentOrder)"/>
        <Button v-if="currentOrder.state!=='makulerad'" label="Makulera" class="p-button-danger" @click="onDelete(currentOrder)"/>
        <Button label="Visa karta" icon="pi pi-map-marker" @click="openMapModal" />
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
  <div v-else class="orderButtonsWrapper container">
      <div class="row">
        <div class="col-md-12">
          <Button label="Visa karta" icon="pi pi-map-marker" @click="openMapModal" />
        </div>
      </div>
  </div>
  <Toast :position="toastPosition" />
</div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator'
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import ActivityTable from '@/components/Activities/ActivityTable'
import OrderHistory from '@/components/Orders/OrderHistory'
import Button from 'primevue/button'
import SplitButton from 'primevue/splitbutton'
import CommentList from '@/components/Comments/CommentList'
import moment from 'moment'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import InputText from 'primevue/inputtext'
import ConnectedDocuments from '@/components/Files/ConnectedDocuments'
import { bus } from '../../main'

export default {
  name: 'FeralcoOrdersDetailsTab',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    Toast,
    Dialog,
    ActivityTable,
    OrderHistory,
    Button,
    SplitButton,
    CommentList,
    TabView,
    TabPanel,
    ConnectedDocuments,
    InputText,
    'moment': moment
  },
  data () {
    return {
      saveButtons: [
        {
          label: 'Spara alla ordrar',
          icon: 'pi pi-check',
          command: () => {
            this.onSaveAll()
          }
        }
      ],
      currentOrder: {},
      currentSchema: {
        groups: [
          {
            fields: []
          }
        ]
      },
      displayModal: false,
      displayModalDocs: false,
      modalCustomerPlaceId: '',
      modalDocs: null,
      activeSchema: {},
      customerName: '',
      opened: [],
      dataArray: [],
      endCustomerName: '',
      editMode: false,
      editedActivity: '',
      isUserScrolling: '',
      handleDebouncedScroll: '',
      showOnScroll: 'showNo',
      previousOrder: null,
      orderHistory: null,
      customerPlacesToReported: [],
      drivers: null,
      orderLiveUpdated: false,
      orderUpdatedLabel: 'Tidigare',
      isExternalUser: false,
      toastPosition: 'topright'
    }
  },
  props: {
    order: {},
    mergedOrders: {}
  },
  watch: {
    order: function (newVal, oldVal) {
      this.currentOrder = newVal
    },
    currentSchema: function (newVal, oldVal) {
      this.currentShema = newVal
    },
    previousOrder: function (newVal, oldVal) {
      this.previousOrder = newVal
    }
  },
  computed: {
    setState: function () {
      return this.currentOrder.state
    }
  },
  async created () {
    this.checkExternalUser()
    this.currentOrder = this.$props.order
    this.currentSchema = await this.getSchema()
    this.activeSchema = this.activeInputs()
    this.getCustomer(11)
    this.getDrivers()
    this.getTrucks()
    this.getTrailers()
    this.getEndCustomer(this.currentOrder.data.DeliveryPlace)
    this.getCustomerPlacesByCustomer(this.currentOrder)
    this.setLoadingPlace(this.currentOrder.data.ItemId.slice(0, 3))
    this.setDecidedLoadingDate()
    this.setDecidedDeliveryDateDate()
    if (this.currentOrder.needsAttention) {
      this.previousOrder = await this.getPreviousOrder()
    }
    this.orderHistory = await this.getOrderHistory()
    bus.$on('removedOrderRow', (id) => {
      this.currentOrder.data.orderRows = this.currentOrder.data.orderRows.filter(function (obj) {
        return obj.id !== id
      })
    })
    bus.$on('addedOrderRow', (orderRow) => {
      this.currentOrder.data.orderRows.push(orderRow)
    })
    bus.$on('addedActivity', (obj, id, activity, action) => {
      if (id === this.currentOrder.data.orderRows[0].id) {
        if (activity.name === 'Avslutad') {
          this.currentOrder.data.orderRows[0].endTime = activity.startTime
          this.currentOrder.data.orderRows[0].state = 'Avslutad'
        } else if (activity.name === 'Lossar') {
          if (action === 'add') {
            this.currentOrder.data.nbrDeliveredDeliveries = this.currentOrder.data.nbrDeliveredDeliveries + 1
          } else if (action === 'delete') {
            this.currentOrder.data.nbrDeliveredDeliveries = this.currentOrder.data.nbrDeliveredDeliveries - 1
          }
        }
        this.currentOrder.data.orderRows[0].actions = obj
      }
    })
    bus.$on('addedTime', obj => {
      if (obj !== '' && obj !== null) {
        var splitTime = obj.split(':')
        if (splitTime[0] !== '' && splitTime[0].length < 2) {
          splitTime[0] = '0' + splitTime[0]
        }
        obj = splitTime[0] + ':' + splitTime[1]
        this.currentOrder.data.DecidedLoadingEndTime = obj
      }
    })
    bus.$on('addedTimeSep', obj => {
      if (obj !== '' && obj !== null) {
        var splitTime = obj.split(':')
        if (splitTime[0] !== '' && splitTime[0].length < 2) {
          splitTime[0] = '0' + splitTime[0]
        }
        obj = splitTime[0] + ':' + splitTime[1]
        this.currentOrder.data.trailerDecidedLoadingEndTime = obj
      }
    })
    bus.$on('showModal', obj => {
      this.modalCustomerPlaceId = obj
      this.displayModal = true
    })
    bus.$on('openModalDocs', docs => {
      this.modalDocs = docs
      this.displayModalDocs = true
    })
    bus.$on('clearDecidedDeliveryDate', (value) => {
      delete this.currentOrder.data.DecidedDeliveryDate
    })
    bus.$on('changedActivitiesOrder', (obj, id) => {
      if (this.currentOrder.data.orderRows[0].id === id) {
        this.currentOrder.data.orderRows[0].actions = obj
      }
    })
    this.handleDebouncedScroll = this._.debounce(this.handleScroll, 100)
    window.addEventListener('scroll', this.handleDebouncedScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleDebouncedScroll)
  },
  methods: {
    checkExternalUser () {
      if (localStorage.getItem('role') === 'Extern') {
        this.isExternalUser = true
      }
    },
    updateLiveField (schemaField, item) {
      this.currentOrder.data[schemaField] = item
    },
    async checkIfOrderUpdated () {
      let latest = await this.$http.get('/api/orders/' + this.$props.order.id)
      let isUpdated = false
      for (let field of this.currentSchema.groups[0].fields) {
        let match = this.matchData(this.currentOrder.data[field.model], latest.data.data[field.model])
        if (match !== '') {
          isUpdated = true
        }
      }
      if (isUpdated) {
        this.$toast.add({severity: 'error', summary: 'Ordern har ändrats', detail: 'Nya värden har kommit in sedan du öppnade ordern.', life: 30000})
        this.previousOrder = latest.data
        this.currentOrder.needsAttention = true
        this.orderLiveUpdated = true
        this.orderUpdatedLabel = 'Nytt värde'
        return true
      }
      return false
    },
    onModelUpdated (newVal, schema) {
      if (schema === 'driver') {
        this.currentOrder.data.activeDriver = newVal
        let driver = this.drivers.find(x => x.id === newVal)
        this.checkPermission(driver)
        if (driver.truckId !== null) {
          this.currentOrder.data.truck = driver.truckId
        }
        if (driver.trailerId !== null) {
          this.currentOrder.data.trailer = driver.trailerId
        }
      } else if (schema === 'trailerDriverName') {
        let driver = this.drivers.find(x => x.id === newVal)
        this.checkPermission(driver)
      }
    },
    checkPermission (driver) {
      let loadingPlace = this.order.data.ItemId.startsWith('SOL') ? 'SOL' : 'VET'
      let productId = this.order.data.ItemId

      if ((loadingPlace === 'VET' && driver.permissionLoadProductFromVet !== 'Ja') ||
      (loadingPlace === 'SOL' && productId === 'SOL-P-EFLOCK90Bulk ' && driver.permissionLoadProdFrSolE90 !== 'Ja') ||
      (loadingPlace === 'SOL' && productId === 'SOL-P-EFLOCK70Bulk ' && driver.permissionLoadProdFrSolE70 !== 'Ja') ||
      (loadingPlace === 'SOL' && productId === 'SOL-P-FeCl3 314' && driver.permissionLoadProdFrSolFE !== 'Ja') ||
      (loadingPlace === 'SOL' && (productId === 'SOL-P-NaOH 25% T' || productId === 'SOL-P-NaOH 32% T' || productId === 'SOL-P-NaOH 50% T') && driver.permissionLoadProdFrSolLut !== 'Ja') ||
      (loadingPlace === 'SOL' && productId === 'SOL-P-PLUSPAC 1465 ' && driver.permissionLoadProdFrSolPlusP !== 'Ja')) {
        this.showNoPermission()
      }
    },
    showNoPermission () {
      this.toastPosition = 'center'
      this.$toast.add({severity: 'warn', summary: 'Vald chaufför har inte rätt behörighet', life: 30000000})
    },
    openMapModal () {
      bus.$emit('openMapModal', null)
    },
    closeModal () {
      this.displayModal = false
    },
    closeModalDocs () {
      this.displayModalDocs = false
    },
    handleScroll (event) {
      this.isUserScrolling = (window.scrollY > 0)
      if (window.scrollY > 300) {
        this.showOnScroll = 'show'
      } else if (window.scrollY === 0) {
        this.showOnScroll = 'showNo'
      }
    },
    async getSchema () {
      const response = await this.$http.get('/api/orders/schema/feralco')
      return response.data.schema
    },
    activeInputs () {
      const activeSchema = Object.assign({}, this.currentSchema)
      activeSchema.groups = activeSchema.groups.filter((c) => c.activeInDetails)
      return activeSchema
    },
    editData (activity) {
      this.editedActivity = activity
    },
    saveData (activity) {
      this.editedActivity = ''
    },
    matchData (current, previous) {
      if (current !== previous) {
        return previous
      } else {
        return ''
      }
    },
    async getPreviousOrder () {
      const response = await this.$http.get('/api/orderlog/previous/' + this.$props.order.id)
      return response.data.order[0]
    },
    flatSchema (groups) {
      let schema = {}
      groups.forEach(g => {
        g.fields.forEach(f => {
          schema[f.model] = f.label
        })
      })
      return schema
    },
    async getOrderHistory () {
      const flattenedSchema = this.flatSchema(this.currentSchema.groups)
      const { data } = await this.$http.get('/api/orderlog/getorderhistory/' + this.$props.order.id)
      for (var i = 0; i < data.diff.length; i++) {
        for (let object of data.diff) {
          object.name = flattenedSchema[object.name] === undefined ? object.name : flattenedSchema[object.name]
        }
      }
      return data.diff
    },
    getDrivers () {
      let driverSelect = this.activeSchema.groups[0].fields.find(field => field.model === 'driver')
      let activeDriverSelect = this.activeSchema.groups[0].fields.find(field => field.model === 'activeDriver')
      let trailerDriverSelect = this.activeSchema.groups[2].fields.find(field => field.model === 'trailerDriverName')
      this.$http
        .get('/api/users/drivers')
        .then(response => {
          var users = response.data
          this.drivers = response.data
          for (var i = 0; i < users.length; i++) {
            if (users[i].permissionADRTank === 'Ja' && users[i].inActive !== 'Ja') {
              driverSelect.values.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
              activeDriverSelect.values.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
              trailerDriverSelect.values.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getTrucks () {
      var trucksSelect = this.currentSchema.groups[1].fields.find(field => field.model === 'truck')
      this.$http
        .get('/api/objectdatas/objectdescriptionid/5')
        .then(response => {
          var trucks = response.data
          for (var i = 0; i < trucks.length; i++) {
            if (!trucks[i].data.inActive) {
              trucksSelect.values.push({'id': trucks[i].id, 'name': trucks[i].data.regnbr})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getTrailers () {
      var trailersSelect = this.currentSchema.groups[1].fields.find(field => field.model === 'trailer')
      this.$http
        .get('/api/objectdatas/objectdescriptionid/8')
        .then(response => {
          var trailers = response.data
          for (var i = 0; i < trailers.length; i++) {
            if (!trailers[i].data.inActive) {
              trailersSelect.values.push({'id': trailers[i].id, 'name': trailers[i].data.regnbr})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getCustomer (customerId) {
      this.$http
        .get('/api/customers/' + customerId)
        .then(response => {
          var customer = response.data.customer
          var customerSelect = this.currentSchema.groups[0].fields.find(field => field.model === 'kund')
          customerSelect.values.push({'id': customer.id, 'name': customer.data.name})
          this.customerName = customer.data.name
        })
        .catch(error => console.log(error))
    },
    toggle (id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    getTotalAmount (orderRowStartTime, orderRowEndTime, actions) {
      let totalAmount = 0
      if (orderRowStartTime !== '' && orderRowEndTime !== '') {
        let startTime = moment(orderRowStartTime)
        let endTime = moment(orderRowEndTime)
        var duration = moment.duration(endTime.diff(startTime))
        let minutes = 0
        let totalBreaks = 0
        actions.forEach((action) => {
          if (action.name === 'Rast') {
            let breakStartTime = moment(action.startTime)
            let breakEndTime = moment(action.endTime)
            var breakDuration = moment.duration(breakEndTime.diff(breakStartTime))
            var breakMinutes = breakDuration.asMinutes()
            totalBreaks = totalBreaks + breakMinutes
          }
        })
        minutes = duration.asMinutes()
        minutes = minutes - totalBreaks
        totalAmount = minutes
        totalAmount = Math.floor(totalAmount / 60) + ',' + totalAmount % 60
      }
      return totalAmount
    },
    getEndCustomer (endCustomerId) {
      endCustomerId = endCustomerId.replace(/\s+/g, '')
      this.$http
        .get('/api/customersplaces/endcustomer/' + endCustomerId)
        .then(response => {
          this.endCustomerName = response.data.endcustomer[0].data.slutkundnamn + ' (' + response.data.endcustomer[0].data.slutkundnr + ')'
        })
        .catch(error => console.log(error))
    },
    getCustomerPlacesByCustomer (order) {
      order.data.DeliveryPlace = order.data.DeliveryPlace.replace(/\s+/g, '')
      var placesSelect = this.currentSchema.groups[4].fields.find(field => field.model === 'CustomerPlaces')
      this.$http
        .get('/api/customersplaces/endcustomer/' + order.data.DeliveryPlace)
        .then(response => {
          var places = response.data.endcustomer.filter(place => place.data.inActive !== true)
          var density = ''
          this.$http
            .get('/api/orders/api/feralco/get-article/' + encodeURIComponent(order.data.ItemId))
            .then(response => {
              density = response.data.density
              for (var i = 0; i < places.length; i++) {
                if (order.data.CustomerPlaces !== undefined) {
                  var kubik = ''
                  var ton = ''
                  for (var b = 0; b < order.data.CustomerPlaces.length; b++) {
                    if (order.data.CustomerPlaces[b].id === places[i].id) {
                      kubik = order.data.CustomerPlaces[b].kubik
                      ton = order.data.CustomerPlaces[b].ton
                    }
                  }
                  this.customerPlacesToReported.push({'id': places[i].id, 'comments': places[i].comments, 'customerPlaceId': places[i].customerPlaceId, 'name': places[i].data.name + ' ' + places[i].data.city, 'address': places[i].data.address, 'kubik': kubik, 'ton': ton, 'density': density, 'artnr': places[i].data.artnr, 'onlyTruck': places[i].data.onlyTruck, 'washAtCustomer': places[i].data.washAtCustomer})
                  placesSelect.values.push({'id': places[i].id, 'comments': places[i].comments, 'docs': places[i].data.fileGroups, 'customerPlaceId': places[i].customerPlaceId, 'name': places[i].data.name + ' ' + places[i].data.city, 'address': places[i].data.address, 'kubik': kubik, 'ton': ton, 'density': density, 'artnr': places[i].data.artnr, 'onlyTruck': places[i].data.onlyTruck, 'washAtCustomer': places[i].data.washAtCustomer, 'showWash': places[i].data.showWash, 'latitude': places[i].data.latitude, 'longitude': places[i].data.longitude})
                } else {
                  this.customerPlacesToReported.push({'id': places[i].id, 'comments': places[i].comments, 'customerPlaceId': places[i].customerPlaceId, 'name': places[i].data.name + ' ' + places[i].data.city, 'address': places[i].data.address, 'kubik': '', 'ton': '', 'density': density, 'artnr': places[i].data.artnr, 'onlyTruck': places[i].data.onlyTruck, 'washAtCustomer': places[i].data.washAtCustomer})
                  placesSelect.values.push({'id': places[i].id, 'comments': places[i].comments, 'docs': places[i].data.fileGroups, 'customerPlaceId': places[i].customerPlaceId, 'name': places[i].data.name + ' ' + places[i].data.city, 'address': places[i].data.address, 'kubik': '', 'ton': '', 'density': density, 'artnr': places[i].data.artnr, 'onlyTruck': places[i].data.onlyTruck, 'washAtCustomer': places[i].data.washAtCustomer, 'showWash': places[i].data.showWash, 'latitude': places[i].data.latitude, 'longitude': places[i].data.longitude})
                }
              }
            })
        })
        .catch(error => console.log(error))
    },
    setDecidedLoadingDate () {
      var decidedLoadingDate = this.order.data.DecidedLoadingDate
      if (decidedLoadingDate === '' || decidedLoadingDate === undefined) {
        this.order.data.DecidedLoadingDate = this.order.data.DateDeliveryLate
      }
    },
    setDecidedDeliveryDateDate () {
      var decidedDeliveryDate = this.order.data.DecidedDeliveryDate
      if (decidedDeliveryDate === '' || decidedDeliveryDate === undefined) {
        if (this.order.data.DateDeliveryEarly === this.order.data.DateDeliveryLate) {
          this.order.data.DecidedDeliveryDate = this.order.data.DateDeliveryLate
        }
      }
    },
    setLoadingPlace (loadingPlace) {
      var DecidedLoadingDate = this.currentSchema.groups[2].fields.find(field => field.model === 'DecidedLoadingDate')
      var trailerDecidedLoadingDate = this.currentSchema.groups[3].fields.find(field => field.model === 'trailerDecidedLoadingDate')
      DecidedLoadingDate.loadingPlace = loadingPlace
      trailerDecidedLoadingDate.loadingPlace = loadingPlace
    },
    async onSave (order) {
      let checkOrderUpdated = await this.checkIfOrderUpdated()
      if (checkOrderUpdated === false) {
        var url = '/api/orders/' + order.id
        if (order.data.preliminary) {
          order.state = 'preliminär'
        } else if (['accepterad', 'aktiv', 'lastad', 'avslutad', 'sparad', 'fakturaredo', 'fakturerad', 'faktureras'].includes(order.state)) {
          order.state = order.state
        } else if (order.data.driver && order.data.truck && order.data.DecidedLoadingDate && order.data.CustomerPlaces.length > 0) {
          order.state = 'skickad'
          order.data['nbrOrderedDeliveries'] = order.data.CustomerPlaces.length
          order.data['nbrDeliveredDeliveries'] = 0
        } else {
          order.state = order.state
        }
        this.$http
          .put(url, {
            order: {
              id: order.id,
              state: order.state,
              data: this._.omit(order.data, 'submit')
            }
          })
          .then(response => {
            this.currentOrder = response.data
            this.toastPosition = 'topright'
            if (order.data.preliminary) {
              this.$toast.add({severity: 'success', summary: 'Order sparad som preliminär', life: 3000})
            } else {
              this.$toast.add({severity: 'success', summary: 'Order sparad', life: 3000})
            }
          })
          .catch(error => console.log(error))
      }
    },
    onSaveAll () {
      for (let order of this.mergedOrders) {
        if (order.type === 'feralco') {
          var url = '/api/orders/' + order.id
          if (order.data.preliminary) {
            order.state = 'preliminär'
          } else if (['accepterad', 'aktiv', 'lastad', 'avslutad', 'sparad', 'fakturaredo', 'fakturerad', 'faktureras'].includes(order.state)) {
            order.state = order.state
          } else if (order.data.driver && order.data.truck && order.data.DecidedLoadingDate && order.data.CustomerPlaces.length > 0) {
            order.state = 'skickad'
            order.data['nbrOrderedDeliveries'] = order.data.CustomerPlaces.length
            order.data['nbrDeliveredDeliveries'] = 0
          } else {
            order.state = order.state
          }
          this.$http
            .put(url, {
              order: {
                id: order.id,
                state: order.state,
                data: this._.omit(order.data, 'submit')
              }
            })
            .then(response => {
              this.currentOrder = response.data
              this.toastPosition = 'topright'
              if (order.data.preliminary) {
                this.$toast.add({severity: 'success', summary: 'Order ' + order.data.SalesId + ' ' + order.data.DeliveryPlaceCity + ' sparad som preliminär', life: 3000})
              } else {
                this.$toast.add({severity: 'success', summary: 'Order ' + order.data.SalesId + ' ' + order.data.DeliveryPlaceCity + ' sparad', life: 3000})
              }
            })
            .catch(error => console.log(error))
        }
      }
    },
    onCopyInfo () {
      let copyInfo = {
        DecidedLoadingDate: this.order.data.DecidedLoadingDate,
        DecidedLoadingEndTime: this.order.data.DecidedLoadingEndTime,
        DecidedLoadingStartTime: this.order.data.DecidedLoadingStartTime,
        DecidedDeliveryDate: this.order.data.DecidedDeliveryDate,
        activeDriver: this.order.data.activeDriver,
        driver: this.order.data.driver,
        forced: this.order.data.forced,
        preliminary: this.order.data.preliminary,
        separateLoadingTrailer: this.order.data.separateLoadingTrailer,
        trailer: this.order.data.trailer,
        trailerAmount: this.order.data.trailerAmount,
        trailerDecidedLoadingDate: this.order.data.trailerDecidedLoadingDate,
        trailerDecidedLoadingEndTime: this.order.data.trailerDecidedLoadingEndTime,
        trailerDecidedLoadingStartTime: this.order.data.trailerDecidedLoadingStartTime,
        trailerDriverName: this.order.data.trailerDriverName,
        truck: this.order.data.truck,
        truckAmount: this.order.data.truckAmount
      }
      for (let order of this.mergedOrders) {
        if (order.type === 'feralco') {
          const entries = Object.entries(copyInfo)
          for (const [key, value] of entries) {
            if (value !== undefined && value !== '') {
              this.$set(order.data, key, value)
            } else {
              this.$set(order.data, key, null)
            }
          }
        }
        this.toastPosition = 'topright'
        this.$toast.add({severity: 'success', summary: 'Informationen kopierad', life: 3000})
      }
    },
    onActivate () {
      this.order.state = 'aktiv'
      var url = '/api/orders/' + this.order.id
      this.$http
        .put(url, {
          order: {
            id: this.order.id,
            state: 'aktiv',
            data: this._.omit(this.currentOrder.data, 'submit'),
            actions: this.activities
          }
        })
        .then(response => {
          this.toastPosition = 'topright'
          this.$toast.add({severity: 'success', summary: 'Order satt som aktiv', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onDelete (order) {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/orders/' + order.id
          this.state = 'makulerad'
          this.$http
            .put(url, {
              order: {
                id: order.id,
                state: 'makulerad',
                data: this._.omit(order.data, 'submit')
              }
            })
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function (e) {
          console.log('Clicked on cancel')
        })
    },
    onCancel () {
      this.$router.go(-1)
    },
    onFinished (order) {
      let message = 'Vill du avsluta ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.state = 'avslutad'
          var url = '/api/orders/' + order.id
          this.$http
            .put(url, {
              order: {
                id: order.id,
                state: 'avslutad',
                data: this._.omit(order.data, 'submit')
              }
            })
            .then(response => {
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onReadyForInvoice (order) {
      let message = 'Vill du sätta ordern redo för fakturering?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          // this.state = 'fakturaredo'
          var url = '/api/orders/' + order.id
          this.$http
            .put(url, {
              order: {
                id: order.id,
                state: 'fakturaredo',
                data: this._.omit(order.data, 'submit')
              }
            })
            .then(response => {
              if (this.$props.mergedOrders.length === 1) {
                this.$router.go(-1)
              } else {
                this.currentOrder.state = 'fakturaredo'
                this.toastPosition = 'topright'
                this.$toast.add({severity: 'success', summary: 'Order satt som redo för fakturering', life: 3000})
              }
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    getActiveTruckPosition () {
      this.$http
        .get('/api/objectdatasWithGPS/' + this.currentOrder.data.truck)
        .then(response => {
          let logData = '<div class="logData"><strong>Logg</strong><ul>'
          let truckName = ''
          let driverName = ''
          if (this.currentOrder.data.orderRows) {
            let orderRow = this.currentOrder.data.orderRows[0]
            truckName = this.currentOrder.data.orderRows[0].truckName
            driverName = this.currentOrder.data.orderRows[0].driverName
            for (var c = 0; c < orderRow.actions.length; c++) {
              var startTime = moment(orderRow.actions[c].startTime).format('MM-DD HH:mm')
              var endTime = ''
              if (orderRow.actions[c].endTime) {
                endTime = '<br/>' + moment(orderRow.actions[c].endTime).format('MM-DD HH:mm')
              }
              logData = logData + '<li><span>' + startTime + endTime + '</span><span>' + orderRow.actions[c].name + '</span></li>'
            }
            var activeState = orderRow.actions.slice(-1)[0].name
          }
          var destination = ''
          if (this.currentOrder.data.DeliveryPlaceCity) {
            destination = this.currentOrder.data.DeliveryPlaceCity
          } else {
            destination = this.currentOrder.data.customerPlaceName
          }
          logData = logData + '</ul></div>'
          let Data = '<div class="mapInfoWrapper"><strong>' + truckName + '</strong><ul><li><span>Ordernr</span><span>' + this.order.id + '</span></li><li><span>Destination</span><span>' + destination + '</span></li><li><span>Chaufför</span><span>' + driverName + '</span></li></ul>' + logData + '</div>'
          var latestGpsLoc = response.data.GpsPositions.slice(-1)[0]
          let truckObj = { State: activeState, OrderType: this.order.type, Name: truckName, Driver: driverName, Order: this.order, OrderId: this.order.id, Destination: destination, Latitude: latestGpsLoc.lat, Longitude: latestGpsLoc.lon, Title: truckName, Data: Data }
          this.dataArray.push(truckObj)
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/FeralcoOrdersDetailsTab.vue